import React, { useEffect, useState, useRef } from 'react';
import Header from '../Component/Header'
import Footer from '../Component/Footer'
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../assets/css/style.css';


function Home() {
    const [services, setServices] = useState([]); // State to store services
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [videoLinks, setVideoLinks] = useState([]);
    const reelsContainerRef = useRef(null);
    const [btsVideos, setBtsVideos] = useState([]);

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/getcategories`);
                if (!response.ok) {
                    throw new Error(`Error: ${response.status}`);
                }
                const result = await response.json();

                // Transform the fetched data to match your services structure
                const transformedData = result.data.map((item) => ({
                    id: item.id,
                    name: item.category,
                    image: `${item.categoryIcon}`, // Prepend the image URL from the environment variable
                }));

                setServices(transformedData);
                setLoading(false);
            } catch (err) {
                setError(err.message);
                setLoading(false);
            }
        };

        fetchServices();
    }, []);


const fetchBTSVideos = async () => {
    const token = localStorage.getItem("authToken");

    try {
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}/getbts`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        const result = await res.json();
        setBtsVideos(result.videos || []);
    } catch (error) {
        console.error(error);
    }
};

useEffect(() => {
    fetchBTSVideos();
}, []);


    return (
        <>

            {/* 🔥 WOW FIX ADDED HERE */}
            <style>{`
                .wow {
                    contain: layout style paint;
                    will-change: opacity, transform;
                }
            `}</style>

            <Header />
            <div style={{ height: "100px" }}></div>

            {/* About Section */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5">

                        {/* Text Column */}
                        <div className="col-12 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="h-100">
                                <p className="text-black text-uppercase mb-2" style={{ color: "#000000ff" }}>About</p>
                                <h1 className="display-6 mb-4">Visora Visuals</h1>

                                <p>
                                    We believe every frame tells a story — a story of craftsmanship, creativity, and vision. Founded with a passion for capturing the world with precision and artistic flair, we specialize in delivering high-quality visual content tailored for the modern professional industry.
                                </p>
                                <p>
                                    From corporate shoots that reflect brand identity, to fashion photography that brings style to life, to food, interior, and product photography that highlights details with perfection — we turn ideas into compelling visuals that speak for themselves.
                                </p>
                                <p>
                                    Our team blends technical expertise with creative thinking, ensuring every project is executed with excellence. Whether it’s building brand presence, showcasing products, or crafting visual experiences, we provide photography solutions that elevate your business.
                                </p>
                            </div>
                        </div>

                        {/* Single Image Column */}
                        <div className="col-12 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="d-flex justify-content-center align-items-center h-100">
                                <img
                                    className="img-fluid"
                                    src="img/About/1.jpg"
                                    alt="About"
                                    style={{
                                        width: "100%",      // Change width here
                                        height: "400px",    // Change height here
                                        objectFit: "cover", // Ensures clean cropping
                                        borderRadius: "12px",
                                        backgroundColor: "#f8f9fa"
                                    }}
                                />
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            {/* About Owner Section */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5">

                        {/* Image Column (Left) */}
                        <div className="col-12 col-md-6 wow fadeInUp" data-wow-delay="0.1s">
                            <div className="d-flex justify-content-center align-items-center h-100">
                                <img
                                    className="img-fluid"
                                    src="img/About/2.webp"  // <-- Change owner image path here
                                    alt="Owner"
                                    style={{
                                        width: "100%",          // Editable
                                        height: "600px",        // Editable
                                        objectFit: "cover",
                                        borderRadius: "12px",
                                        backgroundColor: "#f8f9fa"
                                    }}
                                />
                            </div>
                        </div>

                        {/* Text Column (Right) */}
                        <div className="col-12 col-md-6 wow fadeInUp" data-wow-delay="0.5s">
                            <div className="h-100">
                                <p className="text-uppercase mb-2" style={{ color: "#000000ff" }}>About</p>
                                <h1 className="display-6 mb-4">Anil Pandey</h1>

                                <p>
                                    the visionary behind Visora Visuals, is an award-winning photographer with over 8+ years of professional experience in the creative industry. His expertise spans across corporate shoots, fashion photography, food photography, interior and architectural shoots, and product photography, making him one of the most versatile visual storytellers in the field.
                                </p>

                                <p>
                                    With a sharp eye for detail and a deep understanding of lighting, composition, and brand aesthetics, Anil has built a reputation for delivering visuals that truly elevate his clients’ presence. His dedication to quality and innovation has earned him 5 prestigious awards, recognizing his talent and contribution to the world of professional photography.
                                </p>

                                <p>
                                    Over the years, Anil has successfully worked with and satisfied 10,000+ clients, ranging from startups and restaurants to corporate giants and well-known brands. Every project he takes on reflects his passion, professionalism, and commitment to excellence.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* BTS Reels Section */}
<div className="container-xxl bg-white py-5 mb-3">
    <div
        className="text-center mx-auto mb-5 wow fadeInUp"
        data-wow-delay="0.1s"
        style={{ maxWidth: "600px" }}
    >

        <h2 className="display-6 mb-3">
            BTS Reels
        </h2>

        <p className="text-muted">
            Take a look behind the camera and experience how we create
            stunning visuals with creativity, teamwork, and passion.
        </p>
    </div>

    <Swiper
        modules={[Navigation, Autoplay]}
        spaceBetween={25}
        navigation
        loop={true}
        autoplay={{
            delay: 3500,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        }}
        speed={1000}
        breakpoints={{
            0: {
                slidesPerView: 1,
            },
            576: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 4,
            },
        }}
    >
        {btsVideos.map((video, index) => (
            <SwiperSlide key={index}>
                <div
                    className="bts-card"
                    style={{
                        borderRadius: "15px",
                        overflow: "hidden",
                        background: "#fff",
                        boxShadow: "0 8px 25px rgba(0,0,0,0.08)",
                        transition: ".3s",
                    }}
                >
<video
    src={video.bts_video_link}
    autoPlay
    muted
    loop
    playsInline
    controls
    preload="metadata"
    style={{
        width: "100%",
        height: "520px",
        objectFit: "cover",
    }}
/>
                </div>
            </SwiperSlide>
        ))}
    </Swiper>
</div>


            {/* Our Clients Section */}
            <div className="container-xxl py-5">
                <div className="container">

                    {/* Top Line */}
                    <hr style={{ borderTop: "2px solid #ddd" }} />

                    {/* Heading */}
                    <h2 className="text-center my-4" style={{ fontWeight: "600" }}>
                        Our Clients
                    </h2>

                    {/* Bottom Line */}
                    <hr style={{ borderTop: "2px solid #ddd" }} />

                    {/* Logo Grid */}
                    <div
                        className="d-flex flex-wrap justify-content-center align-items-center gap-4 py-4"
                        style={{ rowGap: "40px" }}
                    >
                        {[
                            "1.png",
                            "2.png",
                            "3.png",
                            "4.png",
                            "5.png",
                            "6.png",
                            "7.png",
                            "8.png",
                            "9.png",
                            "10.png",
                            "11.png",
                            "12.png",
                            "13.png",
                            "14.png",
                            "15.png",
                            "16.png",
                            "17.png",
                            "18.png",
                            "19.png",
                            "20.png",
                            "21.png",
                            "22.png",
                            "23.png",
                            "24.png",
                            "25.png",
                            "26.png",
                            "27.png",
                            "28.png",
                            "29.png",
                            "30.png",
                            "31.png",
                            "32.png",
                            "33.png",
                            "34.png",
                            // Add more files as needed
                        ].map((file, index) => (
                            <div
                                key={index}
                                style={{
                                    width: "150px",
                                    height: "120px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    padding: "10px",
                                    border: "1px solid #eee",
                                    borderRadius: "8px",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
                                }}
                            >
                                <img
                                    src={`img/logo/${file}`}
                                    alt="Client Logo"
                                    style={{
                                        maxWidth: "180%",
                                        maxHeight: "180%",
                                        objectFit: "contain"
                                    }}
                                />
                            </div>
                        ))}
                    </div>

                    {/* Bottom Line */}
                    <hr style={{ borderTop: "2px solid #ddd" }} />

                </div>
            </div>

            <Footer />
        </>
    )

}

export default Home
